import { render, staticRenderFns } from "./changeContent.vue?vue&type=template&id=32fd3929&scoped=true&"
import script from "./changeContent.vue?vue&type=script&lang=js&"
export * from "./changeContent.vue?vue&type=script&lang=js&"
import style0 from "./changeContent.vue?vue&type=style&index=0&id=32fd3929&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32fd3929",
  null
  
)

export default component.exports